import { Modal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../enums/modalId";
import LetterUploadScreenshot from "./components/letterUploadScreenshot";

interface LetterUploadDocProps {
  onCancel: () => void;
  filePath: string;
  loading?: boolean;
  error?: string | null;
  formattedTime: string;
}

const LetterUploadDoc = ({
  onCancel,
  filePath,
  loading,
  error = null,
  formattedTime,
}: LetterUploadDocProps) => {
  return (
    <Modal
      dialogId={ModalId.LETTER_UPLOAD_DOC}
      title="Letter Upload"
      onClose={onCancel}
      onSave={() => {}}
      saveButtonText="Save"
      cancelText="Cancel"
      heightPercentage={70}
      hideFooter={true}
    >
      <div className="flex h-full flex-col">
        <div className="flex flex-1 overflow-hidden">
          <div className="flex h-full w-full flex-1 flex-col bg-primaryGray-16 pb-3">
            <LetterUploadScreenshot
              filePath={filePath}
              loading={loading ?? false}
              error={error}
              formattedTime={formattedTime}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default LetterUploadDoc;
